import { FunctionComponent } from "react";

import { SectionWithFiltersAndSearch } from "./SectionWithFiltersAndSearch";
import { SectionWithResourcesTable } from "./SectionWithResourcesTable";

interface Props {
  organizationId?: string;
}

// This component is used Resources page where we have Filters and Search with Table of ALL resources records
// But Organizations page \ ID \ Organization page \ Tab Resources reuses Filters, Search, Table for single organization data
export const ResourcesOverview: FunctionComponent<Props> = () => {
  return (
    <div
      data-testid="all-resources-container"
      className="mt-3 rounded-md bg-white p-4 shadow-[0_4px_20px_0_rgba(0,0,0,0.1)]"
    >
      <SectionWithFiltersAndSearch />
      <SectionWithResourcesTable />
    </div>
  );
};
